// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"Sidebar__sidebar__2zd_w","showSidebar":"Sidebar__showSidebar__6ZVU4","toggle":"Sidebar__toggle__11HLL","content":"Sidebar__content__ylFMN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Sidebar/Sidebar.css
// module id = 80
// module chunks = 0